import en from "./platform-pages/en.json";
import fr from "./platform-pages/fr.json";
import es from "./platform-pages/es.json";
import it from "./platform-pages/it.json";
import de from "./platform-pages/de.json";
import el from "./platform-pages/el.json";
import ru from "./platform-pages/ru.json";
import sr from "./platform-pages/sr.json";
import zh from "./platform-pages/zh.json";
import type { Landing } from "./seoContent";

export type PlatformPage = Landing & { seo: { title: string; description: string }; alt: { hero: string; side: string } };
export type PlatformKey = keyof typeof en;

const BUNDLES: Record<string, Record<string, PlatformPage>> = { en, fr, es, it, de, el, ru, sr, zh } as never;

export const PLATFORM_KEYS = Object.keys(en) as PlatformKey[];
export const PLATFORM_ROLE_KEYS: PlatformKey[] = ["owners", "engineers", "pursers", "hods"];
export const PLATFORM_FEATURE_KEYS = PLATFORM_KEYS.filter((k) => !PLATFORM_ROLE_KEYS.includes(k));
export const PLATFORM_BY_PATH: Record<string, PlatformKey> = Object.fromEntries(
  PLATFORM_KEYS.map((k) => [(en as Record<string, PlatformPage>)[k].path, k]),
);
export const getPlatformPage = (lang: string, key: string): PlatformPage =>
  (BUNDLES[lang] ?? BUNDLES.en)[key] ?? BUNDLES.en[key];
/** Locale key prefix used by the SEO plugins, e.g. "crew-hr" → "seo.ppCrewHr". */
export const platformSeoKey = (key: string) => "pp" + key.split("-").map((p) => p[0].toUpperCase() + p.slice(1)).join("");
